<template>    
  <Toast />
    <div class="row">
        <div class="col">
            <h2 class="titre">Modification Jeux</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :isModifier="true"/>
    <ButtonBar @fermer="fermer" @sauvegarder="sauvegarder" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation"/>     
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBarJeux.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsJeux.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  name: 'jeuxModifier',
  components: {
    ButtonBar,
    ModifierChamps,
    DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
      newJeuxLocal: [],
      jeuxASupprimer: [],
    };
  },
	computed: {
		...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil'
		})
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier jeux");
  },
  methods: {
    sauvegarder() {
      this.newJeuxLocal = this.$refs.modifierChamps.getNewJeuxLocal();
      this.jeuxASupprimer = this.$refs.modifierChamps.getJeuxASupprimer();
      if (this.newJeuxLocal.length !== 0) {
        this.isSauvegardeEnCours = true;
        this.$store.dispatch('jeux/sauvegarderJeuxAction', {
          jeux: this.newJeuxLocal,
        }).then((res) => {
          if (res?.data?.messages.length == 0){
            if(this.jeuxASupprimer.length == 0){
              this.msgSucces();
            }
          } else {
            this.isSauvegardeEnCours = false;
            this.$root.$refs.messagesComp.messagesList = res.data.messages;
          }
        });
      }
      if(this.jeuxASupprimer.length !== 0){
        this.isSauvegardeEnCours = true;
        this.jeuxSupprimerLien();
      }
    },
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();
    },
    jeuxSupprimerLien(){
      this.$store.commit('dossier/SUPPRIMER_LIEN_JEUX', this.jeuxASupprimer);
      this.$store.dispatch('jeux/supprimerJeuxAction', {
        jeux: this.jeuxASupprimer,
      }).then((res) =>{
        if(res.status == 200 || res.status == 202 || res.status == 201) {
          this.msgSucces();
        }else {
          this.isSauvegardeEnCours = false;
          this.$root.$refs.messagesComp.messagesList = res.data.messages;
        }
      });
    },
    msgSucces(){
      this.isSauvegardeEnCours = false;
      this.$toast.add({
        severity:'success',
        summary: 'Modification',
        detail:'La liste de jeu a été modifiée.',
        life: 6000
      });
      this.$store.dispatch("jeux/consulterJeuxAction", {
        cle: this.$route.params.cleDossier,
        site: this.$route.params.siteDossier
      });
    }
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.$refs.modifierChamps.getJeuxLocal(), this.$refs.modifierChamps.getAncienJeuxLocal());
  },    
};
</script>
